<template>
  <div class="container mt-4" style="height: 1080px">
    <div class="row" style="height: 100%">
      <div class="col" style="height: 100%">
        <div style="height: 100%">
          <iframe
            :src="src"
            width="100%"
            height="100%"
            frameborder="0" >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      src: null
    }
  },
  watch: {
    '$route.params.frame_id': function () {
      this.loadFrame()
    }
  },
  mounted () {
    if (this.$route.params.frame_id === undefined) {
      this.$router.push('/view/frame/' + this.$store.state.project.views.find(obj => obj.type === 'frame').id)
    } else {
      this.loadFrame()
    }
  },
  methods: {
    loadFrame () {
      const frame = this.$store.state.project.views.filter(obj => obj.type === 'frame' && obj.id === parseInt(this.$route.params.frame_id))[0]
      this.src = frame.url
    }
  }
}
</script>
